import { MondayLogo } from "frontend/icons/monday-logo";
import UpgradeModalGeneric, { UpgradeModalNeededProps } from "./upgrade-modal";
import { getPathPrefix } from "../../utils/getPathPrefix";

export default function UpgradeModalForMondayIntegration(props: UpgradeModalNeededProps) {
  return (
    <UpgradeModalGeneric
      trackingEvent="monday-integration"
      title={
        <span>
          Unlock all <MondayLogo height={8.83} width={15} /> <b>monday</b>
          <small>.com</small> integrations
        </span>
      }
      content={"Generate live, dynamic visualizations of your monday.com boards with just a one click."}
      bulletpoints={[
        "Blazing fast multiplayer",
        "Task management",
        "Commenting",
        "A world of templates",
        "Quality file export",
      ]}
      image={getPathPrefix("/images/upgrade-modal-images/upgrade-for-monday-integration.png")}
      {...props}
    />
  );
}
